/* eslint-disable react/no-unescaped-entities */
// import { useGetCompetitionTerms } from 'app/core/api/referral/api-referral';
// import { CompetitionTerms } from 'app/core/api/referral/api-referral.types';
import Body from 'app/shared/components/typography/body/Body';
import Subheading from 'app/shared/components/typography/subheading/Subheading';
import React from 'react';

export default function TermsAndConditions(): JSX.Element {
  return (
    <>
      <Subheading>Terms and Conditions Motorcycle Live</Subheading>
      <Body>
        <p>
          1. The promoter of the competition is iWarranty Limited
          (Company No: 1201479) whose registered office address is
          19-21 Crawford Street, London W1H1PJ (“Promoter”).
        </p>
        <p>
          2. Enquiries regarding competitions can be directed at the
          Promoter’s marketing team at support@iwarranty.co
        </p>
        <p>
          3. These terms and conditions together with any specific
          additional rules set out in the Competition are the
          Completion Rules (“Rules”) and apply to the Promoter’s
          competition (“Competition”). By entering a Competition, an
          entrant is indicating his/her agreement to be bound by these
          terms and conditions.
        </p>
        <p>
          4. Rules specific to the Competition on MotorcycleLive
          website or on the website for iWarranty ("Competition").{' '}
        </p>
        <p>
          5. The Promoter reserves the right to cancel or amend the
          competition and these terms and conditions without notice in
          the event of a catastrophe, war, civil or military
          disturbance, act of God or any actual or anticipated breach
          of any applicable law or regulation or any other event
          outside of the Promoter’s control. Any changes to the
          competition will be notified to entrants as soon as possible
          by the Promoter.
        </p>
        <p>
          6. The Promoter is not responsible for inaccurate prize
          details supplied to any entrant by any third party connected
          with this competition.
        </p>
        <Subheading>Qualifying for Competition</Subheading>
        <p>
          7. To qualify to enter the Competition you must be resident
          in the United Kingdom. The address you provide with your
          competition entry ("Entry") may be used to send prize so
          please make sure this is correct.{' '}
        </p>
        <p>
          7.1 Qualifying entry means:
          <ul>
            <li>You must be aged 19 or over</li>
            <li>UK resident or Citizen</li>
            <li>Hold a valid motorcycle licence</li>
            <li>Download the iWarranty app</li>
            <li>Upload three (3) products</li>
          </ul>
        </p>
        <p>
          8. By entering the Competition, you hereby warrant that all
          information submitted by you is true, current, and complete.
          The Promoter reserves the right to verify the eligibility of
          all entrants.
        </p>
        <p>
          9. The Promoter assumes that by reading the publication or
          by using the website and entering the Competition (and you
          warrant that) you are aged 19 or over or, if you are under
          19, that your parents have consented to your entry into the
          Competition and these Rules and you need to hold a valid
          motorcycle licence.{' '}
        </p>
        <p>
          10. The Promoter reserves the right to disqualify any
          entrant if it has reasonable grounds to believe the entrant
          has breached any of the Rules.
        </p>
        <p>
          11. In the event that any entrant is disqualified from the
          Competition, the Promoter in its sole discretion may decide
          whether a replacement should be selected. In this event, any
          further entrant will be selected on the same criteria as the
          original entrant and will be subject to these Rules.
        </p>
        <Subheading>Entries for Competition</Subheading>
        <p>
          12. There is no entry fee and no purchase necessary to enter
          this competition.{' '}
        </p>
        <p>
          13. Competition entries must be made in the manner and by
          the closing date specified on the Competition. Failure to do
          so will disqualify the entry.
        </p>
        <p>
          14. Entrants who referred multiple friends to enter the
          competition will qualify to enter more than once, provided
          the referred friends have made the Qualifying entry to the
          Competition.{' '}
        </p>
        <p>
          14.1 A winner will be selected on the basis of Qualifying
          entry to the Competition. If there is no response from the
          Winner for 48 hours, the Promoter reserves the right to
          select an alternative winner. Any further winner will be
          selected on the same criteria as the original winner and
          will be subject to these Rules.
        </p>
        <Subheading>Prize & Conditions</Subheading>
        <p>
          15. The Competition is to win a Super Socco TC with Single
          battery (“the Prize”). Prize includes the first registration
          fee and number plate. The prize must be collected from the
          Super Socco dealership. Any future road tax payments are to
          be borne by the winner. The Prize does not include
          insurance, which shall be the responsibility of the winner
          and a live policy must be in place before the bike is
          collected. Choice of colour of the Prize is not available
          and the Prize will be the bike displayed at the motorcycle
          live. Future maintenance of the Prize must be borne by the
          winner. The Promoters take no responsibility for any
          mechanical, body or paint repairs and/or modifications made
          to the Prize from the date and time of collection.
        </p>
        <p>
          15.1 The following additional terms and conditions apply to
          the Competition:
          <ul>
            <li>
              To be eligible to win the Prize you must be aged 19 or
              over and download the iWarranty app and upload three (3)
              products.
            </li>
            <li>
              The Draw is open to all UK residents aged 19 or over,
              with a valid motorcycle licence.{' '}
            </li>
            <li>No purchase necessary.</li>
            <li>
              Only those Qualifying entries will be entered into the
              Competition.
            </li>
            <li>
              Entries must be received by no later than 11pm on 11th
              December 2022 (Closing Date). However the Promoter has
              the right to extend the Closing Date of the Competition.
              Entries received after the Closing Date will not be
              accepted.
            </li>
            <li>
              The winner will be selected at random on 15th December
              2022.
            </li>
            <li>
              The winner will be notified by email. The email address
              you used to create the user account on iWarranty app
              will be used to notify the winner.
            </li>
            <li>
              A letter of collection will be emailed to the winner
              within 7 days. If the winner cannot be contacted or does
              not claim the prize within 7 days of notification, we
              reserve the right to withdraw the prize from the winner
              and draw a replacement winner.
            </li>
            <li>
              The Prize can be collected from a Super Socco authorised
              dealership within the UK and the winner must present a
              copy of the letter for collection sent via email. All
              costs related to the collection of the prize are to be
              borne by the competition winner.
            </li>
            <li>
              The mileage on the Super Socco TC may be more than zero
              as a result of, for example, testing of the Vehicle or
              delivery to a Super Soco dealer. The mileage will not be
              more than 100 miles.
            </li>
            <li>
              When the winner collects the vehicle, You must show your
              photographic UK driving licence to the Super Soco dealer
              to verify. Your identity and a utility bill to verify
              your address. You may also show Your passport to verify
              your identity. The dealer may refuse to allow you to
              collect the vehicle if you don’t provide this
              identification when asked.
            </li>
            <li>
              The winner may be featured in promotional material and
              be required to take part in other PR activity on social
              media and other PR materials without entitlement to any
              financial reward.{' '}
            </li>
            <li>
              The Prize is not transferable without the Promoter’s
              prior written agreement and no cash alternative is
              available.
            </li>
            <li>
              Entrants agree to these rules by entering the prize draw
            </li>
            <li>
              For iWarranty UKs full privacy policy please visit:{' '}
              <a href="https://iwarranty.co/privacy-policy/">
                iWarranty Privacy Policy
              </a>
            </li>
          </ul>
        </p>
        <p>
          16. The Promoter will notify the winner when and where the
          prize can be collected.
        </p>
        <p>
          17. The Prize winner will be notified in the manner and
          within the time specified on the Competition Notice. Return
          of any prize notification as undeliverable or failure to
          reply as specified in the notification (and within the time
          stated) may result in disqualification and selection of an
          alternate winner. Competition winner’s name may be published
          on appropriate social media channels of iWarranty and Green
          Repair Network and/or the{' '}
          <a href="www.iwarranty.co">website</a>.
        </p>
        <p>
          18. Claims for prizes must be made in the manner and within
          the time specified on the Competition. Failure to claim a
          prize within this time or in the manner specified may result
          in withdrawing the prize from the winner and the selection
          of an alternate winner.
        </p>
        <p>
          19. The prize is as stated and no cash or other alternatives
          will be offered. The prizes are not transferable. We reserve
          the right to substitute any prize with another of equivalent
          value without giving notice.
        </p>
        <p>
          20. Prizes are awarded at the discretion of the Promoter and
          no prizes will be awarded as a result of improper actions by
          or on behalf of any entrant.
        </p>
        <p>
          21. Where a prize may not be appropriate for a younger
          contestant, the minimum age for entry or a person without a
          valid motorcycle licence will be stated in the Competition
          and must be observed. The Promoter reserves the right to
          request written proof of age of any winner and his/her valid
          motorcycle licence.
        </p>
        <Subheading>Promoter's Liability</Subheading>
        <p>
          22. The Promoter cannot accept any responsibility for any
          damage, loss, injury or disappointment suffered by any
          entrant entering the competition or as a result of accepting
          any prize or usage of the prize which is provided without
          any guarantees or warranties of any kind, either express or
          implied, including but not limited to warranties of
          merchantability, fitness for a particular purpose, of title,
          or of noninfringement of third party rights. Use of the
          product by a user is at the user’s risk and any issues must
          be resolved directly with the manufacturer. The Promoter is
          not responsible for any problems or technical malfunction of
          the Prize or computer on-line systems, servers, or
          providers, computer equipment or software, failure of any
          email or entry to be received on account of technical
          problems or traffic congestion on the Internet, telephone
          lines or at any website, or any combination thereof,
          including any injury or damage to entrant's or any other
          person's computer or mobile telephone related to or
          resulting from participation in the competition. Nothing
          shall exclude the Promoter’s liability for death or personal
          injury as a result of its negligence.
        </p>
        <Subheading>Data Protection and Publicity</Subheading>
        <p>
          23. Winners may be requested to take part in promotional
          activity and the Promoter reserves the right to use the
          names and addresses of winners in any publicity both in
          paper and online.{' '}
        </p>
        <p>
          24. Any personal data relating to the winner or any other
          entrants will be used solely in accordance with the United
          Kingdom’s Data Protection Legislation and any subordinate
          legislation passed under the Act.
        </p>
        <p>
          25. Any personal data relating to entrants will not be
          disclosed to a third party without the individual’s consent.
        </p>
        <p>
          26. Please see the Promoters Data Protection Notice and
          Privacy Policy For further details. Data relating to
          entrants will be retained by the Promoter for a reasonable
          period after the competition closes to assist the Promoter
          to operate competitions in a consistent manner and to deal
          with any queries on the competition.
        </p>
        <Subheading>Governing Jurisdiction</Subheading>
        <p>
          27. The competition and these terms and conditions shall be
          governed by and construed in accordance with English law.
          You and the Promoter irrevocably agree that the courts of
          England shall have exclusive jurisdiction over any claim or
          matter or to settle any dispute which may arise out of or in
          connection with these Terms & Conditions and that
          accordingly any proceedings may be brought in such courts.
        </p>
        <p>
          We only will accept entries into the competitions where the
          entrant complied with the Competition Rules connected to
          downloading iWarranty app, user registration, and uploading
          3 products. Those who haven’t complied with this requirement
          will not be entered into the competition.
        </p>
        <p>
          Note: Competition close date as of now is 11 December 2022,
          this will be extended or modified at the discretion of the
          Promoter.
        </p>
      </Body>
    </>
  );
}
